/// <amd-module name="Feed/Admin/Redux/GlobalSettings/GlobalSettingsSelectors" />
import { IGlobalPermissionData } from "../../Types";
import { IGlobalSettingsAwareState } from "./GlobalSettingsContracts";

export function getGlobalPermissionData(state: IGlobalSettingsAwareState): IGlobalPermissionData {
    const settingsState = state.globalSettingsState;
    return (
        settingsState && {
            ...settingsState,
            creatorIds: settingsState.everyoneIsCreator ? [] : settingsState.creatorIds
        }
    );
}
